'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToCurrentProperties = ['ui', action.feis_id];

  switch (action.type) {
    case 'SET_CURRENT_ANNOUNCE_EVENT':
      return state.setIn([].concat(pathToCurrentProperties, ['currentEvent']), action.event_id);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/announce/index.js
// module id = 689
// module chunks = 0